import React from 'react';
import { getNestedValue, calculateDday, getColorClasses, safeDisplayValue } from './utils';

/**
 * DateInfoWidget - Renders date with optional D-day badge
 * 
 * Config structure:
 * {
 *   label: "다음 보전 예정일",
 *   dataKey: "next_maintenance_date",
 *   showDday: true,
 *   color: "orange" (optional, defaults to orange)
 * }
 */
export default function DateInfoWidget({ config, data }) {
  if (!config) return null;

  const dateValue = safeDisplayValue(getNestedValue(data, config.dataKey, null), null);
  const colors = getColorClasses(config.color || 'orange');
  
  // Calculate D-day if enabled
  let ddayValue = null;
  let ddayText = '';
  
  if (config.showDday && dateValue) {
    ddayValue = calculateDday(dateValue);
    if (ddayValue !== null) {
      ddayText = ddayValue === 0 ? 'D-Day' : ddayValue > 0 ? `D-${ddayValue}` : `D+${Math.abs(ddayValue)}`;
    }
  }

  return (
    <div className="flex items-center justify-between px-1">
      <span className="text-[12px] text-slate-400 font-medium">{config.label}</span>
      <div className="flex items-center gap-2">
        <span className={`text-[13px] ${colors.text} font-black tracking-tight`}>
          {dateValue || '-'}
        </span>
        {config.showDday && ddayValue !== null && (
          <span 
            className={`px-1.5 py-0.5 rounded ${colors.bgLight} text-[9px] font-black`}
            style={{ color: colors.text.replace('text-', '').replace('-400', '-300') }}
          >
            {ddayText}
          </span>
        )}
      </div>
    </div>
  );
}
